import { Navigate, useLocation } from "react-router-dom";

import { createRerouteRegex } from "App/routes/pageNames";
import { LegacyPagePaths } from "App/routes/paths";
import { useLiveOpsPathing } from "Pages/liveOps/useLiveOpsPathing";

export function RecentActivityRerouter(): JSX.Element {
    const location = useLocation();
    const { recentActivityBasePath } = useLiveOpsPathing();
    const pathAfterRecentActivity = location.pathname.replace(createRerouteRegex(LegacyPagePaths.recentActivity), "");
    const newPath = pathAfterRecentActivity
        ? `${recentActivityBasePath}/${pathAfterRecentActivity}${location.search}${location.hash}`
        : `${recentActivityBasePath}${location.search}${location.hash}`;
    return <Navigate to={newPath} replace />;
}
